<wc-wrapper [contentWrapper]="wrapper">
  @if (videoSequencer) {
    <sd-video-sequencer sd-component-wrapper-component
      [sdSpyTarget]="componentUid"
      [videoSequencer]="videoSequencer"
    />
  }
</wc-wrapper>
